import { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import {
  NOTIFICATION_LEVEL_ERROR,
  NOTIFICATION_LEVEL_SUCCESS,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import envConfig from '../../../envConfig';
import { pushSessionMessage } from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import { refreshFilteredAlertList } from '../../../redux/slices/alertListSlice/alertListSlice';

const useBulkDeleteAlert = () => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();

  const bulkDelete = (alertIdList, onComplete) => {
    const counts = {
      success: 0,
      error: 0,
    };
    setSubmitting(true);
    const requests = alertIdList.map((alertId) => {
      const formData = new FormData();
      formData.append('id', alertId);
      return axios.post(`${envConfig.raaUrl}/alerts/data/delete-alert`, formData)
        .then(() => {
          counts.success += 1;
        })
        .catch(() => {
          counts.error += 1;
        });
    });
    Promise.allSettled(requests).finally(() => {
      if (counts.success > 0) {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_SUCCESS,
          title: 'Success',
          body: `${counts.success} Alerts Deleted.`,
          duration: 10000,
        }));
        dispatch(refreshFilteredAlertList());
      }

      if (counts.error > 0) {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_ERROR,
          title: 'Errors occurred',
          body: `${counts.error} Alerts had an unexpected error while deleting.`,
          duration: 10000,
        }));
        dispatch(refreshFilteredAlertList());
      }

      setSubmitting(false);
      setSubmitted(true);
      onComplete();
    });
  };

  return {
    bulkDelete,
    submitting,
    submitted,
  };
};

export default useBulkDeleteAlert;
